// extracted by mini-css-extract-plugin
export default {"container":"znjNN","noSpacing":"_6et1x"};